import request from '@/utils/http';

// 游客登录获取token
export const guestLogin = (data) => {
  return request.post('/user/guestLogin', data);
};
